import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last Updated: January 2024</p>

      <h2>1. Introduction</h2>
      <p>Welcome to Raix ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Discord bot.</p>

      <h2>2. Information We Collect</h2>
      <h3>2.1 Automatically Collected Information</h3>
      <p>When you use Raix, we may automatically collect certain information, including:</p>
      <ul>
        <li>Discord User ID</li>
        <li>Discord Server (Guild) ID</li>
        <li>Message content (only when necessary for bot functionality)</li>
        <li>Command usage data</li>
        <li>Server configuration settings</li>
      </ul>

      <h3>2.2 Information You Provide</h3>
      <p>We collect information that you voluntarily provide when:</p>
      <ul>
        <li>Using bot commands</li>
        <li>Configuring bot settings</li>
        <li>Interacting with bot features</li>
        <li>Contacting our support team</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>We use the collected information for the following purposes:</p>
      <ul>
        <li>To provide and maintain our bot services</li>
        <li>To improve and optimize bot performance</li>
        <li>To respond to your requests and provide customer support</li>
        <li>To detect, prevent, and address technical issues</li>
        <li>To send you updates and important notifications</li>
        <li>To analyze usage patterns and improve features</li>
      </ul>

      <h2>4. Data Storage and Security</h2>
      <p>We implement appropriate technical and organizational security measures to protect your information against unauthorized access, alteration, disclosure, or destruction. Your data is stored securely on encrypted servers with limited access.</p>

      <h2>5. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access your personal information</li>
        <li>Request correction of inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Opt-out of data collection (by removing the bot from your server)</li>
      </ul>

      <h2>6. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at:</p>
      <p>Email: <a href="mailto:factsonly9667@gmail.com">factsonly9667@gmail.com</a><br/>
      Discord: <a href="https://discord.gg/5tUh6aktZw" target="_blank" rel="noopener noreferrer">Join our support server</a></p>

      <div style={{ marginTop: '4rem' }}>
        <Link to="/" className="btn-secondary">Back to Home</Link>
      </div>
    </div>
  );
};

export default Privacy;
